import {useSelector} from "react-redux";

export const useUserSelector = () => {
    return  useSelector( ({user}) => {
        return user
    })
};
